import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { MarkdownContainer } from "./styles";

const privacyMarkdown = `# 개인정보 처리방침

마고(이하 "회사")는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 및 관련 개인정보 보호 법령을 준수하며, 회원(이하 "회원")의 개인정보 보호를 위해 최선의 노력을 다하고 있습니다. 본 방침은 회원의 권익 보호 및 개인정보 관련 고충의 원활한 처리를 위해 마련되었으며, 관련 법령 및 회사의 내부 규정에 따라 변경될 수 있습니다. 본 방침의 시행일은 2025년 8월 1일입니다.

## 1. 개인정보의 수집 및 이용

회사는 서비스의 기본 기능을 수행하기 위한 최소한의 개인정보만을 수집합니다. 회원에게 최적화된 서비스 제공을 위해 추가 정보 수집이 필요할 경우, 회사는 사전에 안내하고 동의를 얻어 진행합니다. 회사는 개인정보를 명시된 이용 목적 이외의 다른 용도로 이용하거나 제3자에게 제공하지 않습니다.

### 수집목적 및 항목

회원으로부터 수집된 개인정보는 다음의 목적으로만 이용되며, 목적 이외의 용도로는 사용되지 않습니다.

| 수집 목적 | 항목 |
| --- | --- |
| 고객관리 | 이메일 주소, 비밀번호, 프로필 정보(닉네임) |
| 약관 변경 등에 대한 동의 | 이메일 주소 |
| 서비스 운영 및 품질 개선 | 음성녹음 파일, 텍스트 변환 및 감정인식 결과물, 편집 텍스트 |
| 서비스 이용 결제 | 수령인 정보, 결제정보, 은행계좌정보, (휴대폰 결제 시) 휴대폰 번호, 현금영수증 정보 |
| 마케팅 및 이벤트 | 이메일 주소, 프로필 정보(닉네임), 휴대폰 번호 |

1. 고객을 관리하는 과정에서 필수항목으로 이메일 주소, 비밀번호, 프로필 정보(닉네임)가 수집됩니다. 관련 항목은 회원가입 및 탈퇴, 서비스 이용을 위한 로그인, 회원 간의 계정 연결 등에 활용됩니다.
2. 회사는 서비스 운영 과정에서 약관 변경 등 운영 방침이 달라질 경우, 회원에게 7일 전에 변경사항을 미리 고지합니다. 서비스 내 공지사항을 활용하거나 회원으로부터 수집한 이메일 주소로 메일을 발생하여 안내합니다.
3. 서비스를 운영하고 품질을 개선하는 과정에서 회원이 서비스에 자발적으로 입력한 데이터나 자동화된 방법으로 생성한 데이터가 수집됩니다. 다음과 같은 생성 데이터는 개인정보가 식별되지 않도록 안전하게 변환하여 수집되며 제공 서비스의 유효성 확인, 앱 오류 분석 및 서비스 개선 등에 활용됩니다. 또한, 서비스 운영 및 처리과정에서 ID 주소, 스마트폰 단말기 정보, 이동통신사 정보, 음성녹음파일, 서비스 접속 일시, 서비스 이용 기록 등의 정보 데이터가 자동으로 생성되어 저장될 수 있습니다.
   - **기기 관련 정보:** 모바일 기기 고유 ID, 모바일 기기 IP주소
   - **서비스 이용기록:** 접속 일시, 앱 상호작용 데이터, 정상·비정상 로그
   - **앱 내 생산활동:** 음성 또는 소리 녹음 파일, 텍스트 변환 내용, 편집 텍스트, 감정인식 분석결과
4. 회사에서 제공하는 별도의 서비스를 이용하기 위해선 추가적인 결제 요청이 발생할 수 있습니다.
5. 회사가 마케팅 및 프로모션을 목적으로 이벤트나 부가서비스를 진행하는 과정에서 이메일 주소, 프로필 정보(닉네임), 휴대폰 번호 등 추가적인 개인정보 수집을 요구할 수 있습니다. 개인정보를 수집하는 시점에서 개인정보의 수집 목적 및 이용, 수집하려는 개인정보의 항목, 수집된 개인정보의 보관기간 등을 안내하고 동의를 받습니다.
6. 단, 제3자의 서비스인 Google Firebase Analytics에서 광고 및 앱 활동 분석 등을 목적으로 회원의 정보를 수집할 수 있습니다. 회원은 기기의 설정에서 사용을 거부할 수 있으며, 자세한 내용은 Google 사용 정책을 확인하시기 바랍니다.
7. 서비스 운영에 필요한 개인정보를 추가로 수집할 경우에 회원에게 수집항목 및 이용목적을 안내드리고 동의를 받아 진행됩니다. 또한, 전자상거래 등에서의 소비자보호에 관한 법률, 국세기본법, 전자금융거래법 등 관련법령에 따라 주민등록번호 및 은행계좌번호의 수집·보관이 불가피한 경우나, 휴대폰 소액결제 등 요금정산을 위하여 이동전화번호정보의 수집·보관이 불가피한 경우에는 이용자에게 고지하여 해당 정보를 수집할 수 있습니다.

## 2. 개인정보의 취급위탁

| 수탁업체 | 위탁업무 내용 |
| --- | --- |
| NHN한국사이버결제(주) | 결제 처리 |
| (주)KG Inicis | 결제 처리 |
| NICE평가정보(주) | 본인 인증 |
| Google LLC | 구글 애널리틱스(Google Analytics)를 통한 통계 분석 |
| Google LLC | 구글 파이어베이스(Firebase Analytics)를 통한 통계 분석 |
| Amplitude | Amplitude를 통한 통계 분석 |
| Appsflyer | 앱 설치 시 유입된 매체 및 사이트 분석 |
| AssemblyAI, Inc. | 서비스 운영 |

## 3. 개인정보의 국외이전

| 수탁업체 | 위치 | 위탁 일시 및 방법 | 정보관리책임자 연락처 | 위탁하는 개인정보 항목 | 위탁업무 내용 |
| --- | --- | --- | --- | --- | --- |
| Amazon Web Services, Inc. | 미국 | 서비스 이용 시 수시로 서버를 통해 전송 | aws-korea-privacy@amazon.com | 아이디, 이메일, 스마트폰 단말 정보(디바이스 모델, OS, 기기아이디), IP Address, 쿠키, 서비스 접속 일시, 서비스 이용기록, 통화녹음파일, 통화상대이름, 전화번호 등 | 서비스 운영 환경 제공 및 데이터 보관 |
| Google LLC | 미국 | 서비스 이용 시 수시로 서버를 통해 전송 | googlekrsupport@google.com | 아이디, 이메일, 스마트폰 단말 정보(디바이스 모델, OS, 기기아이디), IP Address, 쿠키, 서비스 접속 일시, 서비스 이용기록, 통화녹음파일, 통화상대이름, 전화번호 등 | 서비스 운영 환경 제공 및 데이터 보관 |
| AssemblyAI, Inc. | 미국 | 서비스 이용 시 수시로 서버를 통해 전송 | support@assemblyai.com | 회원이 입력한 음성 및 영상 파일, 통화녹음파일 | 서비스 운영 환경 제공 |

## 4. 개인정보의 이용기간 및 파기

회사는 수집된 개인정보의 이용 목적이 달성된 후 즉시 해당 정보를 파기합니다.

- **기본 보관 기간:** 관련 법령에 따라 1년간 보유 후 삭제
- **음성 및 텍스트 데이터:** 서비스 성능 개선 목적 동의 시 분리·암호화 후 최대 5년까지 보관, 이후 파기
- **탈퇴 시:** 회원 탈퇴 시 개인정보는 30일간 식별 불가 상태로 보관 후 완전 삭제
- **파기 방법:** 전자 파일은 복구 불가 방식으로, 종이 문서는 분쇄 또는 소각

## 5. 정보주체와 법정대리인의 권리·의무 및 행사방법

회원은 언제든지 개인정보의 열람·정정·삭제·처리정지 등을 요청할 수 있습니다. 권리는 이메일, 서면, 앱 내 고객센터를 통해 행사할 수 있습니다.

## 6. 개인정보 제공 및 공유

회사는 회원의 동의 없이 개인정보를 외부에 제공하거나 공유하지 않습니다. 다만 관련 법령의 특별한 요구가 발생하는 경우에는 회원에게 사전 동의 없이 제3자에게 제공될 수 있습니다.

1. 관계 법령에 의해 국가기관으로부터 요구받은 경우
2. 범죄에 대한 수사상의 목적 또는 정보통신 윤리위원회의 요청이 있는 경우
3. 기타 관계 법령에서 정한 절차에 따른 요청이 있을 경우

## 7. 개인정보 파기 절차 및 방법

개인정보 처리 목적이 달성되거나, 이용자의 파기 요청이 있을 경우 회사는 지체 없이 해당 개인정보를 파기합니다.

개인정보의 파기 절차 및 방법은 다음과 같습니다.

### 파기절차
- 관련법령에 따라 개인정보를 보관할 경우, 해당 정보를 별도로 분리 및 암호화해서 보관하고, 보관의 목적으로만 이용합니다.
- 서비스 이용과정에서 수집되는 음성, 텍스트 정보는 서비스 성능향상 및 개선 목적으로만 사용되며, 이용자가 서비스 해지시 개인정보와 분리되어 5년 동안 암호화해서 보관한 다음 파기합니다.
- 그 외에 개인정보는 관련법령에 따라 일정기간 보관을 하고 개인정보 처리 목적이 달성되면 지체 없이 파기합니다.

### 파기방법
- 종이로 보관되어 있는 개인정보는 분쇄기로 분쇄하거나 소각 등으로 파기합니다.
- 전자적 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 또는 물리적 방법으로 삭제합니다.

### 파기기한

**회사 내부방침에 따른 파기기한:**

| 보관항목 | 보관이유 | 보관기간 |
| --- | --- | --- |
| 이메일 주소, 비밀번호, 프로필 정보(닉네임) | 신용정보의 수집/처리 및 이용, 분쟁해결 및 수사기관 요청 | 1년 |
| 부정 이용기록 | 서비스 부정 방지 및 부정 이용자의 재가입 방지 | 1년 |

**관련법령에 따른 파기기한:**

| 관련법령 | 보관항목 | 보관이유 | 보관기간 |
| --- | --- | --- | --- |
| 통신비밀보호법 | 부정/불량 이용기록 | 법원의 영장을 받아 수사기관이 요청시 제공 | 3개월 |

## 8. 개인정보 처리방침 변경

본 개인정보 처리방침은 정부의 개인정보 관련 법령 및 회사 내부 방침에 따라 변경될 수 있습니다. 개인정보 처리방침의 변경은 개인정보의 수집 및 활용, 제3자 제공 등 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 관련법령에 따라 고객의 별도 동의를 받은 후에 시행됩니다. 회사는 변경사항 시행 7일 전에 서비스 내 공지사항이나 이메일을 통해 회원에게 사전 안내할 것입니다. 다만, 회원에게 불리한 사항이 추가되거나 수정되는 경우에는 시행 30일 전에 공지합니다.

## 9. 개인정보의 안전성 확보 조치

회사는 회원의 개인정보가 유출, 분실, 도난, 변경, 훼손이 되지 않도록 기술적, 물리적 조치를 하고 있습니다.

- 개인정보의 암호화
- 개인정보 유출 방지를 위한 기술적 대책
- 개인정보에 대한 관리계획 수립 및 시행
- 개인정보 취급에 대한 내부 필수교육

## 10. 개인정보 관리 및 보호책임자

회사는 회원의 개인정보를 보호하고, 관련 문의 및 요청에 빠르게 대응하고자 개인정보 관리 및 보호책임자를 지정하고 있습니다. 서비스를 이용하시는 과정에서 개인정보에 대한 문의, 민원 및 불만처리, 피해구제 등을 신청하실 수 있으며 회사는 문의사항에 신속하고 정확하게 답변드리겠습니다.

- **개인정보 보호책임자 성명:** 권석봉
- **직책:** CTO
- **연락처:** galois@holamago.com

---

**공고일자:** 2024년 3월 26일  
**시행일자:** 2024년 3월 26일`;

const PrivacyPage: React.FC = () => {
  return (
    <MarkdownContainer>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{privacyMarkdown}</ReactMarkdown>
    </MarkdownContainer>
  );
};

export default PrivacyPage;
